import axios from "axios";

type UnsplashPhoto = {
    id: string,
    urls: {
        thumb: string,
        small: string,
        regular: string
    },
    user: {
        name: string,
        links: {
            html: string,
        }
    }
}

export type UnsplashCollection = {
    total: number,
    total_pages: number,
    results: UnsplashPhoto[]
}

export const getUnsplashImages = async (keyword: string, page: number) => {
    let queryArgs = "";

    if (page) queryArgs += `&page=${page}`;
    if (keyword) queryArgs += `&keyword=${keyword}`;

    const { data } = await axios.get<UnsplashCollection>(
        `/api/unsplash/search?${queryArgs}`,
    );

    return data;
}